import DocumentAPI from "../../api/document.js";
import router from "../../router";

export const document = {
    namespaced: true,
    state: {
        years: [],
        year: "current",
        documents: [],
        document: {
            rows: []
        },
        types: {
            1: "Fattura",
            2: "Nota di Credito",
            3: "Pubblica Amministrazione"
        }
    },
    actions: {
        YEARS: ({ commit }) => {
            DocumentAPI.YEARS()
                .then(response => {
                    commit("YEARS", response.data);
                })
                .catch(() => {
                    commit("YEARS", []);
                });
        },

        YEAR: ({ commit }, data) => commit("YEAR", data),

        DOCUMENTS: async ({ commit }, data) =>
            DocumentAPI.DOCUMENTS(data.year)
                .then(response => {
                    commit("DOCUMENTS", response.data);
                })
                .catch(() => {
                    commit("DOCUMENTS", {});
                }),

        DOCUMENT: ({ commit }, data) => {
            DocumentAPI.DOCUMENT(data.id)
                .then(function (response) {
                    commit("DOCUMENT", response.data);
                })
                .catch(function () {
                    commit("DOCUMENT", {});
                });
        },

        PRINT: ({ }, doc) => DocumentAPI.DOWNLOAD(doc.id).then(response => {
            const url = window.URL.createObjectURL(response.data);
            const link = window.document.createElement('a');
            link.href = url;
            link.setAttribute('target', '_blank');
            link.setAttribute('download', `${moment(doc.date).format('YYYY-MM-DD')}_${doc.number}.pdf`);
            console.log(`${moment(doc.date).format('YYYY-MM-DD')}_${doc.number}.pdf`);
            window.document.body.appendChild(link);
            link.click();
        }).catch(console.log),

        RESET: ({ commit }) => {
            commit("DOCUMENT", {
                rows: []
            });
        },

        SAVE: ({ commit }, document) => DocumentAPI.SAVE(document)
            .then(({ data: doc }) => {
                commit('DOCUMENT', doc);
                document.id ? null : router.replace('/documents/' + doc.id)
            }),

        DELETE: ({ state }) => DocumentAPI.deleteDocument(state.document.id)
            .then(() => router.replace('/documents'))
            .catch(error => alert(error.response.data)),
    },

    mutations: {
        YEARS: (state, years) => state.years = years,

        YEAR: (state, year) => state.year = year,

        DOCUMENTS: (state, documents) => state.documents = documents,

        DOCUMENT: (state, document) => state.document = document,

        addDocument(state, document) {
            state.documents.push(document);
        }
    }
};
